import { StateService } from '@uirouter/angular';
import { Component, Input, OnInit } from '@angular/core';
import { GfTitleService } from '../../../core/services/core.title.service';
import * as _ from 'lodash';
import { normalizeCommitish } from '../services/scm.utils';

@Component({
  selector: 'scm-browse',
  template: require('./scm.browse.component.html'),
})
export class ScmBrowseComponent implements OnInit {
  emptyRepository = false;
  @Input() project: any;
  @Input() scm: any;
  @Input() breadcrumbs: any;

  commitish: string = '';
  scmBrowseText: any = false;

  constructor(
    private titleService: GfTitleService,
    private stateService: StateService
  ) {}

  ngOnInit() {
    const params = this.stateService.params;

    this.commitish = normalizeCommitish(
      params['branch'] ||
      params['tag'] ||
      params['commit'] ||
      _.get(this.scm, 'defaultBranchName', '')
    );

    if (this.scm?.options?.browseText ?? null) {
      this.scmBrowseText = {
        type: 'markdown',
        title: _.get(this.project, 'name', ''),
        glyph: 'glyphicon-info-sign',
        content: this.scm?.options?.browseText,
      };
    }

    const path = this.stateService.params['path'];
    this.titleService.setTitle(this.project.name, _.startCase(this.scm.scmType) + ' Browse', path ? '/' + path : '');
  }
}
